import React, { Component } from 'react';
import zxcvbn from 'zxcvbn';
import { Notification } from '../Notification';
import { Filler } from './components/Filler';
import './PasswordStrength.css';

export interface Props {
  password: string;
}

const getResultLabel = (result: any) => {
  switch (result.score) {
    case 1:
      return 'Weak';
    case 2:
      return 'Fair';
    case 3:
      return 'Good';
    case 4:
      return 'Strong';
    default:
      return 'Weak';
  }
};

export const PasswordStrength = (props: Props) => {
  const { password } = props;
  const result = zxcvbn(password);
  const resultLabel = getResultLabel(result);
  const percentage = (result.score / 4) * 100;
  const passwordStrengthClass = password ? 'password-strength-wrapper' : 'password-strength-wrapper--hidden';

  return (
    <div className={passwordStrengthClass}>
      <div className="progress-bar">
        <Filler percentage={percentage} strength={result.score} />
      </div>
      <Notification type="info" message={`Password Strength: ${resultLabel}`} />
    </div>
  );
};
